<template>
  <div>
    <app-spinner v-if="!is_loaded" />
    <template v-else>
      <app-grid class="grid--indent">
        <template #item-1>
          <app-cells><h2 class="title">Companies</h2></app-cells>
          <v-client-table
            :data="table_companies.items"
            :columns="table_companies.columns"
            :options="table_companies.options"
            class="table-default"
          >
            <template #h__name><div class="table-default__left">Name</div></template>
            <template #index="{ row, index }">{{ index }}</template>
            <template #name="{ row }"><div class="table-default__left">{{ row[0] }}</div></template>
            <template #count="{ row }">{{ row[1].count }}</template>
          </v-client-table>
        </template>
      </app-grid>
      <app-grid>
        <template #item-1>
          <app-cells><h2 class="title">Positions</h2></app-cells>
          <v-client-table
            :data="table.items"
            :columns="table.columns"
            :options="table.options"
            class="table-default"
          >
            <template #h__name><div class="table-default__left">Name</div></template>
            <template #index="{ row, index }">{{ index }}</template>
            <template #name="{ row }"><div class="table-default__left">{{ row[0] }}</div></template>
            <template #count="{ row }">{{ row[1].count }}</template>
            <template #compensation="{ row }">{{ row[1].compensation.toLocaleString() }} TSh</template>
            <template #salary="{ row }">{{ row[1].average_salary.toLocaleString() }} TSh</template>
          </v-client-table>
        </template>
        <template #item-2>
          <app-cells><h2 class="title">Departments</h2></app-cells>
          <v-client-table
            :data="table_departments.items"
            :columns="table_departments.columns"
            :options="table_departments.options"
            class="table-default"
          >
            <template #h__name><div class="table-default__left">Name</div></template>
            <template #index="{ row, index }">{{ index }}</template>
            <template #name="{ row }"><div class="table-default__left">{{ row[0] }}</div></template>
            <template #count="{ row }">{{ row[1].count }}</template>
            <template #compensation="{ row }">{{ row[1].compensation.toLocaleString() }} TSh</template>
          </v-client-table>
        </template>
      </app-grid>
    </template>
  </div>
</template>

<script>
import { getEmployeesAnalyticsPositions, getEmployeesAnalyticsCompanies, getEmployeesAnalyticsDepartments } from '@/http'
export default {
  name: 'EmployeesAnalyticsSummary',
  data() {
    return {
      is_loaded: false,
      table: {
        items: [],
        columns: ['index', 'name', 'count', 'compensation', 'salary'],
        options: {
          headings: {
            'index': '#',
            'name': 'Name',
            'count': 'Count',
            'compensation': 'Compensation',
            'salary': 'Average salary',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 1000,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      table_departments: {
        items: [],
        columns: ['index', 'name', 'count', 'compensation'],
        options: {
          headings: {
            'index': '#',
            'name': 'Name',
            'count': 'Count',
            'compensation': 'Compensation',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 1000,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      table_companies: {
        items: [],
        columns: ['index', 'name', 'count'],
        options: {
          headings: {
            'index': '#',
            'name': 'Name',
            'count': 'Count',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 1000,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
    }
  },
  created() {
    Promise.all([
      this.fetchItems(),
      this.fetchItemsDepartments(),
      this.fetchItemsCompanies(),
    ]).then(() => { this.is_loaded = true })
  },
  methods: {
    async fetchItems() {
      const response = await getEmployeesAnalyticsPositions()
      this.table.items = Object.entries(response.data.instances)
    },
    async fetchItemsDepartments() {
      const response = await getEmployeesAnalyticsDepartments()
      this.table_departments.items = Object.entries(response.data.instances)
    },
    async fetchItemsCompanies() {
      const response = await getEmployeesAnalyticsCompanies()
      this.table_companies.items = Object.entries(response.data.instances)
    },
  }
}
</script>
